/* eslint-disable */
import React, { Component } from "react";
import Store from "../../content/Store";
import Content from "../../content/Content";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styles from "../../assets/css/modules/myprofile/myprofilecommunicationprefs.css";
import OnboardingCommunicationPreferenceSection from "../shared/OnboardingCommunicationPreferenceSection";
import PreferenceRequired from '../shared/PreferenceRequired';
import { isGDPRSet } from "../../services/PersonConsent";
import SSOContainer from "../shared/containers/SSOContainer";
import { Paths } from "../../constants/UrlConstants";
import mfaStyles from "../../assets/css/modules/containers/MFASSOContainer.css";
import {
  saveCommunicationPreferences,
  loadOptionValues,
  setIsCommValueChanged,

} from "../../actions/policy/policyActions";
import MFASSOContainer from "../shared/containers/MFASSOContainer";
import InternalViewButton from "../shared/buttons/InternalViewButton";
import contactPreferenceStyles from "../../assets/css/modules/preference/contact-preferences.css";
import OnBoardingLogout from "../../components/logout/OnboardingLogOut";
import SetCommPreferenceSection from "../shared/SetCommPreferenceSection";
import SetCommunicationPreference from "../shared/SetCommunicationPreference";
import {CommunicationPref} from "../../constants/Constants";

export const mapStateToProps = ({ policyReducer = {}, preferenceReducer = {} ,onboardingReducer={},layoutReducer ={} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const isInternalView =
    policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView;
  return {
    Layout: layoutReducer.layout,
    onboardingFlag :onboardingReducer.isUserOnboarding,
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    Members: selectedPolicy && selectedPolicy.Members,
    PersonConsent: selectedPolicy && selectedPolicy.PersonConsent,
    isInternalView,
    disabled:
      policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView,
    communicationPreferenceKeys: preferenceReducer.communicationPreferencekeys,
    communicationValue: preferenceReducer.communicationValue,
    saveCommunicationPref: preferenceReducer.saveCommunicationPref,
    isElgibleCustomised: preferenceReducer.isElgibleCustomised,
    HasMultiplePolicies:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.HasMultiplePolicies,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCommunicationPreferences: (membershipNumber, updateCommunicationPreferences) =>
      dispatch(saveCommunicationPreferences(membershipNumber, updateCommunicationPreferences)),
    loadOptionValues: (MembershipNumber) => dispatch(loadOptionValues(MembershipNumber)),
    setIsCommValueChanged: (Value) => dispatch(setIsCommValueChanged(Value)),
  };
};


const parent={
  display:'flex',
};

const child ={
  float: 'left',
};
const childLink ={
  float: 'left',
  padding:'8px',
};
const childContainer = {
  fontsize: '15px'
};


export class CommunicationPreference extends Component {
  constructor(props) {
    super(props);
    // console.log("props",props);
    // console.log("communicationValue",communicationValue);
    this.state = {
      PersonConsent: props.PersonConsent,
      shownErrors: null,
      preferenceErrors: false,
      preferenceUpdateSuccess: false,
      contactPreferenceUpdateSucceeded: false,
      updateCommunicationPreferences: null,
      shownCommErrors: false,
      commPrefsUpdateSucceeded: false,
      MemberName: null,
      noSelectionError: false,
      IsOnChange: false,
      noChangesError: false,
      SelectedOption:false
    };
    this.onSkipClick = this.onSkipClick.bind(this);
    this.onCommunicationPreferenceSubmit = this.onCommunicationPreferenceSubmit.bind(this);
  }

  onSkipClick(e) {
    e.preventDefault();
    var consent = Object.assign({}, this.props.PersonConsent);
    this.setState({
      PersonConsent: consent
    });

    if(!isGDPRSet(this.props.PersonConsent)){
      this.props.history.push(Paths.PersonConsent);
    }
    else if(this.props.onboardingFlag){
      this.props.history.push(Paths.DocumentPreference);
    }
    else{
      this.props.history.push(Paths.HomeRoot);
    }
  }

  componentDidMount() {
    if (this.props.Members !== null && this.props.Members !== undefined) {
      let loggedInMember = this.props.Members.find((val) => val.IsLoggedInMember === true);
        if(loggedInMember !== null && loggedInMember !== undefined)
        {
        this.setState({ MemberName:loggedInMember.FullName});
      }
    }
  }

  onCommunicationPreferenceSubmit(e) {
    e.preventDefault();
    this.props.setIsCommValueChanged(false);
    if (this.state.updateCommunicationPreferences !== null &&
      this.state.updateCommunicationPreferences.length !== 0) {
      const idx = this.state.updateCommunicationPreferences.some(m => m.CommunicationPreferenceId.toString() === CommunicationPref.NoThanks && m.IsDeleted === false) ||
        this.state.updateCommunicationPreferences.some(m => m.CommunicationPreferenceId.toString() === CommunicationPref.DocumentsInBraille && m.IsDeleted === false) ||
        this.state.updateCommunicationPreferences.some(m => m.CommunicationPreferenceId.toString() === CommunicationPref.DocumentsInLargePrint && m.IsDeleted === false) ||
        this.state.updateCommunicationPreferences.some(m => m.CommunicationPreferenceId.toString() === CommunicationPref.Audio && m.IsDeleted === false) ||
        this.state.updateCommunicationPreferences.some(m => m.CommunicationPreferenceId.toString() === CommunicationPref.Dyslexic && m.IsDeleted === false)
      if (this.state.updateCommunicationPreferences.length >= 1 && idx === true) {
        if (this.state.updateCommunicationPreferences.length >= 1) {
          this.setState({
            shownCommErrors: false,
            noSelectionError: false,
            commPrefsUpdateSucceeded: false,
            IsOnChange: false,
            noChangesError: false,
          });
          let IsDeletedTrue = [];
          if (this.state.updateCommunicationPreferences.length !== 0) {
            IsDeletedTrue = this.state.updateCommunicationPreferences.filter((val) => {
              return val.IsDeleted === true;
            });
          }
          const idx1 = this.state.updateCommunicationPreferences.findIndex(m => m.CommunicationPreferenceId.toString() === CommunicationPref.NoThanks)
          if (idx1 !== -1) {
            this.state.updateCommunicationPreferences.splice(idx1, 1)
          }
          this.props
            .saveCommunicationPreferences(
              this.props.MembershipNumber,
              this.state.updateCommunicationPreferences,
            )
            .then(() => {
              if (this.props.saveCommunicationPref !== null &&
                this.props.saveCommunicationPref !== undefined &&
                this.props.saveCommunicationPref !== false) {

                if (!isGDPRSet(this.props.PersonConsent)) {
                  this.props.history.push(Paths.PersonConsent);
                }
                else if (this.props.onboardingFlag) {
                  this.props.history.push(Paths.DocumentPreference);
                }
                else {
                  this.props.history.push(Paths.HomeRoot);
                }
                this.props.loadOptionValues(this.props.MembershipNumber);
                if (this.state.updateCommunicationPreferences.length > 0 &&
                  this.state.updateCommunicationPreferences.length === IsDeletedTrue.length &&
                  this.props.communicationValue.length === this.state.updateCommunicationPreferences.length
                ) {

                  this.setState({
                    noSelectionError: true,
                    shownCommErrors: false,
                    commPrefsUpdateSucceeded: false,
                    IsOnChange: false,
                    noChangesError: false,
                  });

                }
                else {
                  this.setState({
                    shownCommErrors: false,
                    noSelectionError: false,
                    commPrefsUpdateSucceeded: true,
                    IsOnChange: false,
                    noChangesError: false,
                  });
                }
              }
              else {
                this.setState({
                  shownCommErrors: true,
                  noSelectionError: false,
                  commPrefsUpdateSucceeded: false,
                  IsOnChange: false,
                  noChangesError: false,
                });
              }
            });
        }
        else (this.state.updateCommunicationPreferences == null)
        {
          if (!isGDPRSet(this.props.PersonConsent)) {
            this.props.history.push(Paths.PersonConsent);
          }
          else if (this.props.onboardingFlag) {
            this.props.history.push(Paths.DocumentPreference);
          }
          else {
            this.props.history.push(Paths.HomeRoot);
          }
        }
      }
      else {
        this.setState({
          noSelectionError: false,
          shownCommErrors: false,
          commPrefsUpdateSucceeded: false,
          IsOnChange: false,
          noChangesError: false,
          SelectedOption: true
        });
      }
    }
    else {
      this.setState({
        noSelectionError: false,
        shownCommErrors: false,
        commPrefsUpdateSucceeded: false,
        IsOnChange: false,
        noChangesError: false,
        SelectedOption: true
      });
    }
  }

  // firstSection = true;
  // commPreference = () => {
  //   if(this.props.communicationPreferenceKeys.length > 0){
  //     for (var i = 0; i < this.props.communicationPreferenceKeys.length; i++) {
  //       if(this.props.communicationPreferenceKeys[i].CommunicationPreferenceId === CommunicationPref.DocumentsInBraille || this.props.communicationPreferenceKeys[i].CommunicationPreferenceId === CommunicationPref.DocumentsInBraille){
  //         this.firstSection = false;      
  //       }
  //       else{
  //         this.firstSection = true; 
  //       }
  //   }
  // }
  // };

  render() {
   
    return (
      window?.axa?.features?.MFAFeature === "true"?
      <MFASSOContainer mfa={true}>
        <div className={styles.myprofilecommunicationprefs}>
          <div className={styles.pageContainer}>
            <PreferenceRequired isPreferenceRequired
              keys={this.props.communicationPreferenceKeys}
              values={this.props.communicationValue}>
              {this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true ?
                this.props.communicationPreferenceKeys !== null &&
                  this.props.communicationValue !== undefined ? (<div className="row">
                    <div id="communicationPreferenceSection" className="col-12">
                    <div className="com-sup-needs-headline">
                      <h1 className={`axa-headline ${contactPreferenceStyles.titlesMFA}`}><Content
                        name={Store.MyProfileCommunicationNeeds.CommSection.HomeHeading}
                      /></h1>
                      </div>
                      {this.state.shownCommErrors ?(
                        <div style={parent} className={
                          "alert alert-danger mt-2 " + styles.messages
                        }>
                          <div style={child}><Content name={Store.MyProfileContactPreferences.SaveContactPreferenceErrorOnboard} /></div>
                          <div style={childLink}><Link
                            to="#"
                            onClick={(e) => this.onSkipClick(e)}
                            id="lnk-Skip"
                          >
                            SKIP
                            <span className="mr-2 left-arrow-back">&#8594;</span>{" "}
                          </Link></div>
                        </div>
                      ):null}


                      <div style={childContainer} >
                        <Content
                          name={Store.MyProfileCommunicationNeeds.CommSection.HomeSubheading}
                        />
                      </div>
                       <hr className={styles.horizontalLine} />
                      {/* <div className={styles.commBox}>     */}
                      <div className={styles.homeFirstSubheading}>
                        <Content
                          name={Store.MyProfileCommunicationNeeds.CommSection.HomeFirstSubheading}
                        />
                      </div>            
                      <Content name={Store.MyProfileCommunicationNeeds.CommSection.HomeFirstSubheadingDescription}/>
                      <SetCommPreferenceSection
                        commPrefsKeys={this.props.communicationPreferenceKeys}
                        communicationValue={this.props.communicationValue}
                        MemberName={this.state.MemberName}
                        Description={null}
                        Layout={this.props.Layout}
                        mfa={true}
                        isCommValueChanged={(value) =>
                          this.setState({
                            IsOnChange: value
                          })}
                        updateCommPreferences={(commprefs) =>
                          this.setState({
                            updateCommunicationPreferences: commprefs,
                            shownCommErrors: null,
                            commPrefsUpdateSucceeded: false,
                            noSelectionError: false,
                            noChangesError: false
                          })
                        }
                        SelectionOption={this.state.SelectedOption}
                        Zebrafied={true}
                        UseSlider={false}>
                      </SetCommPreferenceSection>
                      {/* </div> */}
                      <br/>
                      {/* <div className={styles.commBox}>     */}
                       <hr className={styles.horizontalLine} />
                      <div className={styles.homeFirstSubheading} >
                        <Content
                          name={Store.MyProfileCommunicationNeeds.CommSection.HomeSecondSubheading}
                        />
                      </div>      
                      <SetCommunicationPreference
                        commPrefsKeys={this.props.communicationPreferenceKeys}
                        communicationValue={this.props.communicationValue}
                        MemberName={this.state.MemberName}
                        Description={null}
                        Layout={this.props.Layout}
                        mfa={true}
                        isCommValueChanged={(value) =>
                          this.setState({
                            IsOnChange: value
                          })}
                        updateCommPreferences={(commprefs) =>
                          this.setState({
                            updateCommunicationPreferences: commprefs,
                            shownCommErrors: null,
                            commPrefsUpdateSucceeded: false,
                            noSelectionError: false
                          })
                        }
                        SelectionOption={this.state.SelectedOption}
                        Zebrafied={true}
                        UseSlider={false}>
                      </SetCommunicationPreference>
                      {/* </div> */}
                      <div id="personconsentMessage">

                        {this.state.noChangesError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content
                              name={
                                Store.MyProfileContactPreferences
                                  .NoChangesMessage
                              }
                            />
                          </div>
                        ) : null}
                      </div>
                      <form onSubmit={this.onCommunicationPreferenceSubmit}>
                        <div className={"row " + styles.commOptionSection}>
                          <div className="col-sm-12 text-center">
                            <button
                                          label={Store.MyProfileContactPreferences.ContinueButton}
                                          className={mfaStyles.buttonStart}
                                        type="submit"
                                        >{Store.MyProfileContactPreferences.ContinueButton}
                              </button>
                          </div>
                        </div>
                        <div className={contactPreferenceStyles.boxContainer}>
                          <div className={this.props.Layout ==='MOL'? contactPreferenceStyles.contentContainerMOL : contactPreferenceStyles.contentContainer}>
                            { Store.MyProfileContactPreferences.AccountText}
                          </div>
                          <div className={contactPreferenceStyles.logoutContainer}>
                            <OnBoardingLogout/>
                          </div>
                        </div>
                      </form>
                    </div>


                  </div>) : (
                  <div
                    className={
                      "alert alert-danger mt-2 " + styles.messages
                    }
                    role="alert"
                  >
                    <Content
                      name={
                        Store.MyProfileCommunicationNeeds.Errors.GetMasterDataFailed
                      }
                    />
                  </div>
                ) : null}
            </PreferenceRequired>

          </div>

        </div>
      </MFASSOContainer>:
      <SSOContainer>
        <div className={styles.myprofilecommunicationprefs}>
          <div className={styles.pageContainer}>
            <PreferenceRequired isPreferenceRequired
              keys={this.props.communicationPreferenceKeys}
              values={this.props.communicationValue}>
              {this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true ?
                this.props.communicationPreferenceKeys !== null &&
                  this.props.communicationValue !== undefined ? (<div className="row">
                    <div id="communicationPreferenceSection" className="col-12">
                    <div className="com-sup-needs-headline">
                      <h1 className={`axa-headline ${contactPreferenceStyles.titles}`}><Content
                        name={Store.MyProfileCommunicationNeeds.CommSection.HomeHeading}
                      /></h1>
                      </div>
                      {this.state.shownCommErrors ?(
                        <div style={parent} className={
                          "alert alert-danger mt-2 " + styles.messages
                        }>
                          <div style={child}><Content name={Store.MyProfileContactPreferences.SaveContactPreferenceErrorOnboard} /></div>
                          <div style={childLink}><Link
                            to="#"
                            onClick={(e) => this.onSkipClick(e)}
                            id="lnk-Skip"
                          >
                            SKIP
                            <span className="mr-2 left-arrow-back">&#8594;</span>{" "}
                          </Link></div>
                        </div>
                      ):null}


                      <div style={childContainer} >
                        <Content
                          name={Store.MyProfileCommunicationNeeds.CommSection.HomeSubheading}
                        />
                      </div>
                       
                      <div className={styles.commBox}>    
                      <div className={styles.homeFirstSubheading}>
                        <Content
                          name={Store.MyProfileCommunicationNeeds.CommSection.HomeFirstSubheading}
                        />
                      </div>            
                      <SetCommPreferenceSection
                        commPrefsKeys={this.props.communicationPreferenceKeys}
                        communicationValue={this.props.communicationValue}
                        MemberName={this.state.MemberName}
                        Description={null}
                        Layout={this.props.Layout}
                        isCommValueChanged={(value) =>
                          this.setState({
                            IsOnChange: value
                          })}
                        updateCommPreferences={(commprefs) =>
                          this.setState({
                            updateCommunicationPreferences: commprefs,
                            shownCommErrors: null,
                            commPrefsUpdateSucceeded: false,
                            noSelectionError: false,
                            noChangesError: false
                          })
                        }
                        SelectionOption={this.state.SelectedOption}
                        Zebrafied={true}
                        UseSlider={false}>
                      </SetCommPreferenceSection>
                      </div>
                      <br/>
                      <div className={styles.commBox}>    
                      <div className={styles.homeFirstSubheading} >
                        <Content
                          name={Store.MyProfileCommunicationNeeds.CommSection.HomeSecondSubheading}
                        />
                      </div>            
                      <SetCommunicationPreference
                        commPrefsKeys={this.props.communicationPreferenceKeys}
                        communicationValue={this.props.communicationValue}
                        MemberName={this.state.MemberName}
                        Description={null}
                        Layout={this.props.Layout}
                        isCommValueChanged={(value) =>
                          this.setState({
                            IsOnChange: value
                          })}
                        updateCommPreferences={(commprefs) =>
                          this.setState({
                            updateCommunicationPreferences: commprefs,
                            shownCommErrors: null,
                            commPrefsUpdateSucceeded: false,
                            noSelectionError: false
                          })
                        }
                        SelectionOption={this.state.SelectedOption}
                        Zebrafied={true}
                        UseSlider={false}>
                      </SetCommunicationPreference>
                      </div>
                      <div id="personconsentMessage">

                        {this.state.noChangesError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content
                              name={
                                Store.MyProfileContactPreferences
                                  .NoChangesMessage
                              }
                            />
                          </div>
                        ) : null}
                      </div>
                      <form onSubmit={this.onCommunicationPreferenceSubmit}>
                        <div className={"row " + styles.commSection}>
                          <div className="col-sm-12 text-center">
                            <InternalViewButton
                              id="btn-contactPreference"
                              type="submit"
                              className="form-control btn btn-submit"
                              //disabled={this.props.disabled}
                              label={
                                Store.MyProfileContactPreferences.ContinueButton
                              }
                              btntype="homeButton"
                            />
                          </div>
                        </div>
                        <div className={contactPreferenceStyles.boxContainer}>
                          <div className={this.props.Layout ==='MOL'? contactPreferenceStyles.contentContainerMOL : contactPreferenceStyles.contentContainer}>
                            { Store.MyProfileContactPreferences.AccountText}
                          </div>
                          <div className={contactPreferenceStyles.logoutContainer}>
                            <OnBoardingLogout/>
                          </div>
                        </div>
                      </form>
                    </div>


                  </div>) : (
                  <div
                    className={
                      "alert alert-danger mt-2 " + styles.messages
                    }
                    role="alert"
                  >
                    <Content
                      name={
                        Store.MyProfileCommunicationNeeds.Errors.GetMasterDataFailed
                      }
                    />
                  </div>
                ) : null}
            </PreferenceRequired>

          </div>

        </div>
      </SSOContainer>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunicationPreference);
